export default "/images/analytics.svg?a40ab0b2b801067d03242bf72edf0fe0";